import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weixin': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M385.2 167.6C391.6 167.6 397.8 167.9 404 168.7 387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4 13 250.8 42.3 294.9 90.9 329L71.6 387.6 139.6 353.5C164 358.3 183.4 363.2 207.8 363.2 214 363.2 219.9 362.9 226.1 362.4 222.1 349.5 219.9 335.8 219.9 321.6 219.8 236.7 292.8 167.6 385.2 167.6zM280.7 114.7C295.2 114.7 304.9 124.4 304.9 139.1 304.9 153.6 295.2 163.3 280.7 163.3 265.9 163.3 251.4 153.6 251.4 139.1 251.5 124.4 266 114.7 280.7 114.7zM144.3 163.3C129.8 163.3 115 153.6 115 139.1 115 124.3 129.8 114.7 144.3 114.7 159.1 114.7 168.7 124.4 168.7 139.1 168.7 153.7 159.1 163.3 144.3 163.3zM563 319.4C563 241.5 485.1 178.1 397.6 178.1 304.9 178.1 232.2 241.5 232.2 319.4S305 460.7 397.6 460.7C416.9 460.7 436.5 455.6 456.2 450.8L509.6 480.1 494.8 431.5C534 402.1 563 363.2 563 319.4zM343.9 294.9C334.2 294.9 324.6 285.2 324.6 275.3 324.6 265.6 334.3 256 343.9 256 358.7 256 368.3 265.7 368.3 275.3 368.3 285.3 358.6 294.9 343.9 294.9zM451 294.9C441.3 294.9 431.7 285.2 431.7 275.3 431.7 265.6 441.4 256 451 256 465.5 256 475.4 265.7 475.4 275.3 475.5 285.3 465.5 294.9 451 294.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/weixin.js
// module id = bb5U
// module chunks = 144